import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function MarkaFlsun() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    document.title = "Flsun 3D Yazıcı Servisi Ankara | QQ-S Pro, Super Racer, V400 Tamir";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ankara\'da Flsun Delta 3D yazıcı tamir ve bakım hizmeti. QQ-S Pro, Super Racer, V400 serisi için profesyonel servis desteği ve orijinal yedek parça.');
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Flsun 3D Yazıcı Servisi",
      "description": "Ankara'da Flsun Delta 3D yazıcı tamir, bakım ve kurulum hizmetleri",
      "provider": {
        "@type": "LocalBusiness",
        "name": "3D Print Pro",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3",
          "addressLocality": "Yenimahalle",
          "addressRegion": "Ankara",
          "postalCode": "06480",
          "addressCountry": "TR"
        }
      },
      "areaServed": "Ankara",
      "brand": {
        "@type": "Brand",
        "name": "Flsun"
      }
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-12 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="mb-8 flex justify-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/ee41a0ba7d6301e339408c7fcc08de38.jpg"
                alt="Flsun Logo"
                className="h-24 object-contain"
              />
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Flsun Delta 3D Yazıcı <span className="text-red-600">Servisi Ankara</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Flsun QQ-S Pro, Super Racer ve V400 serisi yüksek hızlı Delta 3D yazıcılarınız için 
              Ankara'da profesyonel tamir, bakım ve teknik destek hizmeti
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
              >
                Randevu Al
              </Link>
              <a 
                href="https://wa.me/903123945635"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
              >
                WhatsApp ile İletişim
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Models Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Servis Verdiğimiz Flsun Modelleri
            </h2>
            <p className="text-xl text-gray-600">
              Tüm Flsun Delta tipi 3D yazıcı modellerinde uzman servis hizmeti
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: "QQ-S Pro",
                models: ["QQ-S", "QQ-S Pro"],
                description: "Popüler Delta tipi yüksek hızlı 3D yazıcı"
              },
              {
                name: "Super Racer",
                models: ["Super Racer", "SR"],
                description: "Ultra hızlı Delta 3D yazıcı (400mm/s)"
              },
              {
                name: "V400",
                models: ["V400"],
                description: "Profesyonel seviye büyük hacimli Delta yazıcı"
              }
            ].map((series, index) => (
              <div 
                key={index}
                className={`bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${200 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-printer-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">{series.name}</h3>
                <p className="text-gray-600 mb-4 text-center">{series.description}</p>
                <ul className="space-y-2">
                  {series.models.map((model, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-red-600 mr-2"></i>
                      {model}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Flsun Delta İçin Sunduğumuz Hizmetler
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-tools-line",
                title: "Delta Mekanik Tamir",
                description: "Delta kinematik sisteminin özel tamiri ve ayarları"
              },
              {
                icon: "ri-settings-3-line",
                title: "Yüksek Hız Optimizasyonu",
                description: "Hızlı baskı için özel bakım ve ayar hizmetleri"
              },
              {
                icon: "ri-compass-3-line",
                title: "Delta Kalibrasyonu",
                description: "Hassas delta kalibrasyon ve seviye ayarları"
              },
              {
                icon: "ri-cpu-line",
                title: "Firmware Güncelleme",
                description: "Klipper ve Marlin firmware optimizasyonu"
              },
              {
                icon: "ri-box-3-line",
                title: "Yedek Parça",
                description: "Orijinal Flsun delta parça tedariki"
              },
              {
                icon: "ri-customer-service-2-line",
                title: "Hız Ayarları",
                description: "Maksimum hız için profil optimizasyonu"
              }
            ].map((service, index) => (
              <div 
                key={index}
                className={`bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Flsun Delta Servisi İçin Neden Bizi Seçmelisiniz?
              </h2>
              <div className="space-y-6">
                {[
                  {
                    title: "Delta Kinematik Uzmanlığı",
                    description: "Delta tipi yazıcılarda özel eğitim almış teknisyen kadrosu"
                  },
                  {
                    title: "Yüksek Hız Deneyimi",
                    description: "Hızlı baskı sistemlerinde uzman servis desteği"
                  },
                  {
                    title: "Hassas Kalibrasyon",
                    description: "Delta sistemler için özel kalibrasyon ekipmanları"
                  },
                  {
                    title: "Orijinal Parça",
                    description: "Sadece orijinal Flsun yedek parçaları kullanıyoruz"
                  }
                ].map((item, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Flsun%20Delta%203D%20printer%20repair%20service%20in%20professional%20workshop%2C%20technician%20working%20on%20high-speed%20delta%20printer%2C%20clean%20technical%20environment%2C%20red%20branding%20elements%2C%20precision%20tools%20and%20delta%20mechanism&width=600&height=500&seq=flsun-service&orientation=landscape"
                alt="Flsun Delta Servis"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Flsun Delta Yazıcınız İçin Hemen Destek Alın
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Uzman ekibimizle iletişime geçin. Ücretsiz ön değerlendirme ve teklif.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim"
              className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              Randevu Al
            </Link>
            <a 
              href="tel:05414565635"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              Hemen Ara: 0541 456 56 35
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/markalar" className="hover:text-white transition-colors">Markalar</Link></li>
                <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0541 456 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
